import axios from 'axios';

export const getEngagementByAddress = (address: string) => {
  return axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/engagement/${address}`)
    .then(response => response.data);
};

export const getEngagementSeason = () => {
  return axios
    .get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/season`)
    .then(response => response.data);
};
